import type { Size } from "@suse-o11y/size";
import { useRequiredContext } from "@suse-o11y/use-required-context";
import { createContext } from "react";

const StageSizeContext = createContext<null | Size>(null);

export const useStageSize = (): Size =>
	useRequiredContext(StageSizeContext, {
		providerName: "Stage",
	});

export const StageContextProvider = StageSizeContext.Provider;
